import axios from "./httpClient";

export function getPortraitReviewApplications(params = {}) {
  return axios.get("/portrait-review", { params });
}
